import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

const appKey = '25ed31147698729a463b'
const endpoint = 'https://uos.unistroyrf.ru/broadcasting/auth'

Pusher.logToConsole = false

export default class PusherService {
  constructor(token) {
    this.echo = null
    this.token = token
  }

  start() {
    this.echo = new Echo({
      broadcaster: 'pusher',
      key: appKey,
      cluster: 'ap1',
      encrypted: true,
      logToConsole: false,
      authEndpoint: endpoint,
      auth: {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      }
    })
  }

  get subscription() {
    return this.echo.connector.pusher
  }

  stop() {
    /**
     * TODO: stop service
     */
  }
}
